import React, { useState, useEffect, useMemo, useCallback } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import NewPlan from "./NewPlan";
import "dayjs/locale/zh-cn";
import KendoTrainingGrid from "./Training/KendoTrainingGrid";
import { CLIENT_SEARCH_FILTERS } from "../../../constants/clientSearchFilters";
import { keyRestrict } from "../../../utils/array";
import { DisplayMsg } from "../../../services/toastService";
import { setUrl } from "../../../handlers";
import { setCurrentClientDetail } from "../../../store/reducers/SharedLayoutDataSlice";

const ProjectPlan = (props) => {
  const dispatch = useDispatch();
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const [ProjectData, setProjectData] = useState([]);

  const [popupPlan, setPopupPlan] = useState(false);
  const [plan, setPlan] = useState({
    Projects: [],
    Trainings: [],
    Trainers: [],
  });
  const [PlanDetail, setPlanDetail] = useState({
    WelcomeDate: null,
    KickDate: null,
    SaleDate: null,
    Billing: "",
    Channel: "",
    Project: "Training Only",
    Practice: "",
    Provider: "",
    Comments: "",
  });
  const [fieldDisable, setFieldDiable] = useState(false);

  const [trainingData, setTrainingData] = useState(null);

  const [Trigger, setTrigger] = useState({ reRender: false });

  const SetClientDetails = (e, type) => {
    if (type != null) {
      if (e != null) {
        setPlanDetail((dateInfo) => ({
          ...dateInfo,
          [type]: e.valueOf(),
        }));
      } else {
        setPlanDetail((dateInfo) => ({
          ...dateInfo,
          [type]: null,
        }));
      }
      // }
    } else {
      setPlanDetail((dateInfo) => ({
        ...dateInfo,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const UpdateClientInfo = async () => {
    if (
      PlanDetail.Practice != null ||
      PlanDetail.Provider != null ||
      PlanDetail.Billing != null ||
      PlanDetail.Channel != null ||
      PlanDetail.Comments != null ||
      PlanDetail.SaleDate != null ||
      PlanDetail.WelcomeDate != null ||
      PlanDetail.KickDate != null
    ) {
      const planData = {
        SEQNUM: sharedData.currentClientId,
        PRACTICEPOC: PlanDetail.Practice,
        PROVIDERPOC: PlanDetail.Provider,
        BILLINGCOMPANY: PlanDetail.Billing,
        KICKOFFCALL_DATE:
          PlanDetail.KickDate != null ? new Date(PlanDetail.KickDate) : null,
        PROJECTTYPE: PlanDetail.Project,
        WELCOMEDATE:
          PlanDetail.WelcomeDate != null
            ? new Date(PlanDetail.WelcomeDate)
            : null,
        COMMENTS: PlanDetail.Comments,
        CHANNEL_PARTNER: PlanDetail.Channel,
        NEW_SALES_DATA:
          PlanDetail.SaleDate != null ? new Date(PlanDetail.SaleDate) : null,
      };
      try {
        const formData = new FormData();
        formData.append("PlanData", JSON.stringify(planData));
        formData.append("seqNum", sharedData.currentClientId);
        document.getElementById("loader").style.display = "block";
        const response = await fetch(
          setUrl("CLIENTDETAIL", "UPDATEPLAN", true),
          {
            method: "POST",
            body: formData,
          }
        );
        const json = await response.json();
        if (json && json.status) {
          DisplayMsg("1", json.Message);
        } else {
          DisplayMsg("2", json.Message);
        }
      } catch (e) {
        DisplayMsg("2", "Unable to Process the Request");
      }
    } else {
      DisplayMsg("2", "Perform an action to update the paln");
    }
  };

  useEffect(() => {
    if (
      sessionStorage.type === "CS" ||
      sessionStorage.type === "CSM" ||
      sessionStorage.type === "M"
    ) {
      setFieldDiable(false);
    } else {
      setFieldDiable(true);
    }

    try {
      const trainersTypes = [];
      document.getElementById("loader").style.display = "block";
      fetch(setUrl("CLIENTDETAIL", "LOADPLANDROPDOWNS", true), {
        method: "GET",
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.status) {
            setPlan((planInfo) => ({
              ...planInfo,
              Projects: json.ProjectTypes.Table,
              Trainings: json.TrainingTypes.Table,
            }));
            const data = {
              EMAIL: "-Select-",
              UUID: "",
            };
            trainersTypes.push(data);
            if (json.Trainners.Table != null) {
              json.Trainners.Table.forEach((item) => {
                const data = {
                  EMAIL: item.EMAIL,
                  UUID: item.UUID,
                };

                trainersTypes.push(data);
              });
            }

            setPlan((planInfo) => ({
              ...planInfo,
              Projects: json.ProjectTypes.Table,
              Trainings: json.TrainingTypes.Table,
              Trainers: trainersTypes,
            }));

            document.getElementById("loader").style.display = "none";
          }
        })
        .catch((error) => {
          document.getElementById("loader").style.display = "none";
          console.log("2", error.Message);
        });
    } catch (e) {
      document.getElementById("loader").style.display = "none";
      console.log("2", "Unable to Process the Request");
    }

    if (sharedData.clientPlanDetail != null) {
      const detail = sharedData.clientPlanDetail;
      setPlanDetail((detailInfo) => ({
        ...detailInfo,
        Billing: detail.BillingCompany,
        Channel: detail.ChannelPartner,
        Comments: detail.ChannelPartner,
        KickDate:
          detail.KickoffCallDate != null
            ? new Date(detail.KickoffCallDate)
            : null,
        SaleDate:
          detail.NewSalesData != null ? new Date(detail.NewSalesData) : null,
        Practice: detail.PracticePoc,
        Provider: detail.ProviderPoc,
        WelcomeDate:
          detail.WelcomeDate != null ? new Date(detail.WelcomeDate) : null,
      }));

      if (detail.ProjectType != null) {
        setPlanDetail((detailInfo) => ({
          ...detailInfo,
          Project: detail.ProjectType,
        }));
      }
    }

    const keyUpHandler = (event) => {
      if (
        event.target.name === "WelcomeDate" ||
        event.target.name === "KickDate" ||
        event.target.name === "SaleDate"
      ) {
        if (event.srcElement.value.length <= 10) {
          if (event.srcElement.value === "") {
            setPlanDetail((dateInfo) => ({
              ...dateInfo,
              [event.target.name]: null,
            }));
          } else {
            setPlanDetail((dateInfo) => ({
              ...dateInfo,
              [event.target.name]: event.srcElement.value,
            }));
          }
        } else {
          const updatedDate = event.srcElement.value.slice(0, 10);
          setPlanDetail((dateInfo) => ({
            ...dateInfo,
            [event.target.name]: updatedDate,
          }));
        }
      }
    };

    document.addEventListener("keyup", keyUpHandler);

    return () => {
      document.removeEventListener("keyup", keyUpHandler);
    };
  }, [props]);

  const renderGrid = useMemo(
    () => ({
      reload: Trigger.reRender,
    }),
    [Trigger.reRender]
  );

  const TriggerProjectPlan = () => {
    setPopupPlan(!popupPlan);
    setTrainingData(null);
  };

  const HandleSetPlan = (childData, plan) => {
    if (plan != null) {
      setProjectData((prevPlan) => [...prevPlan, plan]);
      setTrigger((prevTrigger) => ({
        ...prevTrigger,
        reRender: !Trigger.reRender,
      }));
    }
    setPopupPlan(childData);
    dispatch(setCurrentClientDetail(null));
  };

  const TrainingStatus = useCallback((data) => {
    setTrainingData(data.training);
    setPopupPlan(data.show);
  }, []);

  const AlterDateValues = (e) => {
    keyRestrict(e, "0123456789");
    if (e.target.value.length <= 10) {
      setPlanDetail((dateInfo) => ({
        ...dateInfo,
        [e.target.name]: e.target.value,
      }));
    }
  };

  return (
    <>
      {popupPlan && (
        <NewPlan
          projectTypes={plan.Projects}
          trainingTypes={plan.Trainings}
          trainersTypes={plan.Trainers}
          trainingData={trainingData}
          parentCallback={HandleSetPlan}
        />
      )}

      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />
      <div className="tab-content">
        <div className="tab-pane active" id="clientDetail">
          <div className="client-section overflow-visible">
            <div className="row">
              <div className="col-md-3 col-sm-3">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Customer ID:
                  </label>
                  <input
                    type="text"
                    value={sharedData.currentClientDetail?.SEQ_NUM}
                    name="Customer"
                    className="field-input"
                    disabled
                  />
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Client :
                  </label>
                  <input
                    type="text"
                    name="Client"
                    className="field-input"
                    value={sharedData.currentClientDetail?.ENTITY_SHORT_NAME}
                    disabled
                  />
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Product:
                  </label>
                  <select
                    className="field-input"
                    value={sharedData.currentClientDetail?.PRODUCT}
                    name="Product"
                    disabled
                  >
                    {CLIENT_SEARCH_FILTERS.PRODUCTS.map((item) => (
                      <option value={item.value}>{item.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-sm-3">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Project Type:
                  </label>
                  <select
                    className="field-input"
                    value={PlanDetail.Project}
                    name="Project"
                    onChange={(e) => SetClientDetails(e)}
                    disabled={fieldDisable}
                  >
                    {plan.Projects.length > 0 &&
                      plan.Projects.map((item) => (
                        <option value={item.PROJECT_TYPE}>
                          {item.PROJECT_TYPE}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Account Type:
                  </label>
                  <select
                    className="field-input"
                    value={sharedData.currentClientDetail?.ACCOUNT_TYPE}
                    name="Account"
                    disabled
                  >
                    {CLIENT_SEARCH_FILTERS.ACCOUNTS.map((account) => (
                      <option value={account.value}>{account.label}</option>
                    ))}
                  </select>
                  <input
                    type="hidden"
                    value=""
                    id="AUTH_ENTITY_SEQ_NUM"
                    name="AUTH_ENTITY_SEQ_NUM"
                  />
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container overflow-visible">
                  <label className="field-placeholder font-medium">
                    Welcome Date:
                  </label>
                  <DatePicker
                    value={
                      PlanDetail.WelcomeDate
                        ? dayjs(PlanDetail.WelcomeDate)
                        : null
                    }
                    onChange={(data) => SetClientDetails(data, "WelcomeDate")}
                    name="WelcomeDate"
                    className="field-input"
                    format="MM/DD/YYYY"
                    placeholder="MM/DD/YYYY"
                    onKeyDown={(e) => AlterDateValues(e)}
                  />
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container overflow-visible">
                  <label className="field-placeholder font-medium">
                    Kick off Call Date:
                  </label>
                  <DatePicker
                    value={
                      PlanDetail.KickDate ? dayjs(PlanDetail.KickDate) : null
                    }
                    onChange={(data) => SetClientDetails(data, "KickDate")}
                    name="KickDate"
                    className="field-input"
                    format="MM/DD/YYYY"
                    placeholder="MM/DD/YYYY"
                    onKeyDown={(e) => AlterDateValues(e)}
                  />
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container overflow-visible">
                  <label className="field-placeholder font-medium">
                    New Sale Date:
                  </label>
                  <DatePicker
                    value={
                      PlanDetail.SaleDate ? dayjs(PlanDetail.SaleDate) : null
                    }
                    onChange={(data) => SetClientDetails(data, "SaleDate")}
                    name="SaleDate"
                    className="field-input"
                    format="MM/DD/YYYY"
                    placeholder="MM/DD/YYYY"
                    onKeyDown={(e) => AlterDateValues(e)}
                  />
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Billing Company:
                  </label>
                  <input
                    type="text"
                    onChange={(e) => SetClientDetails(e)}
                    name="Billing"
                    disabled={fieldDisable}
                    className="field-input"
                    value={PlanDetail.Billing}
                    maxLength={100}
                  />
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Channel Partner:
                  </label>
                  <input
                    type="text"
                    onChange={(e) => SetClientDetails(e)}
                    name="Channel"
                    disabled={fieldDisable}
                    value={PlanDetail.Channel}
                    className="field-input"
                    maxLength={55}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 col-sm-6">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Practice POC:
                  </label>
                  <input
                    type="text"
                    onChange={(e) => SetClientDetails(e)}
                    name="Practice"
                    disabled={fieldDisable}
                    className="field-input"
                    value={PlanDetail.Practice}
                    maxLength={100}
                  />
                </div>
              </div>

              <div className="col-md-6 col-sm-6">
                <div className="field-container">
                  <label className="field-placeholder font-medium">
                    Provider POC:
                  </label>
                  <input
                    type="text"
                    onChange={(e) => SetClientDetails(e)}
                    name="Provider"
                    disabled={fieldDisable}
                    className="field-input"
                    value={PlanDetail.Provider}
                    maxLength={100}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="">
                  <label className="field-placeholder label-top-text font-medium">
                    Comments:
                  </label>
                  <textarea
                    rows="2"
                    type="text"
                    disabled={fieldDisable}
                    value={PlanDetail.Comments}
                    cols="10"
                    className="field-input w-100 mt-3"
                    maxLength="4000"
                    name="Comments"
                    onChange={(e) => SetClientDetails(e)}
                  />
                </div>
              </div>
            </div>

            {fieldDisable === false && (
              <div className="row">
                <div className="col-2 text-center w-full">
                  <input
                    type="button"
                    className="btnLinkGreen btnUpdate"
                    onClick={() => UpdateClientInfo()}
                    value="Save Plan"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="tab-pane" id="clientTask">
        <div role="tabpanel" className="tab-pane active" id="clientTask">
          <div className="table-panel task-table m-t-15">
            <div className="row table-panel-header">
              <div className="col-md-8 col-sm-8">
                <h6>Training</h6>
              </div>
              <div className="col-md-4 col-sm-12">
                <div className="row flex-center-end row">
                  <div className="col-md-4 col-sm-4">&nbsp;</div>
                  {fieldDisable === false && (
                    <div className="col-md-2 col-sm-2 flex-center-end">
                      <div className="popuop_open">
                        <span
                          className="popuop_button popupBtn"
                          role="button"
                          onClick={() => TriggerProjectPlan()}
                        >
                          Add
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* renderGrid={renderGrid} */}

            <div className="table-panel-body">
              <KendoTrainingGrid
                AlterTrainingState={TrainingStatus}
                reRender={Trigger.reRender}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectPlan;
